export default {
  path: '/siteregularCtms',
  component: () => import(/* webpackChunkName: 'ctms' */'@/views/project/siteregularCtms/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '/siteregularCtms/project',
      name: 'projectView',
      component: () => import(/* webpackChunkName: 'projectView' */'@/views/project/siteregularCtms/p_project/index')
    },
    {
      path: '/siteregularCtms/project/contractMilestones',
      name: 'contractMilestones',
      component: () => import(/* webpackChunkName: 'contractMilestones' */'@/views/project/siteregularCtms/p_project/contractMilestones')
    },
    {
      path: '/siteregularCtms/project/payPlanMilestones',
      name: 'payPlanMilestones',
      component: () => import(/* webpackChunkName: 'payPlanMilestones' */'@/views/project/siteregularCtms/p_project/payPlanMilestones')
    },
    {
      path: '/siteregularCtms/center',
      name: 'center',
      component: () => import(/* webpackChunkName: 'center' */'@/views/project/siteregularCtms/p_center/view')
    },
    {
      path: '/siteregularCtms/center/milestone',
      name: 'centerMilestone',
      component: () => import(/* webpackChunkName: 'centerMilestone' */'@/views/project/siteregularCtms/p_center/milestone')
    },
    {
      path: '/siteregularCtms/center/patient',
      name: 'centerPatient',
      component: () => import(/* webpackChunkName: 'centerPatient' */'@/views/project/siteregularCtms/p_center/patient')
    },
    {
      path: '/siteregularCtms/center/sae',
      name: 'centerPatient',
      component: () => import(/* webpackChunkName: 'centerPatient' */'@/views/project/siteregularCtms/p_center/sae')
    },
    {
      path: '/siteregularCtms/center/icf',
      name: 'icf',
      component: () => import(/* webpackChunkName: 'icf' */'@/views/project/siteregularCtms/p_center/icf')
    },
    {
      path: '/siteregularCtms/center/monitoringIssues',
      name: 'monitoringIssues',
      component: () => import(/* webpackChunkName: 'monitoringIssues' */'@/views/project/siteregularCtms/p_center/monitoringIssues')
    },
    {
      path: '/siteregularCtms/trails',
      name: 'ctmstrails',
      component: () => import(/* webpackChunkName: 'ctmstrails' */'@/views/project/siteregularCtms/p_trails/index')
    },
    {
      path: '/siteregularCtms/project/milestone',
      name: 'ctmsMilestone',
      component: () => import(/* webpackChunkName: 'ctmsMilestone' */'@/views/project/siteregularCtms/p_project/milestoneSimple')
    },
    {
      path: '/siteregularCtms/project/milestonePlan',
      name: 'ctmsMilestonePlan',
      component: () => import(/* webpackChunkName: 'ctmsMilestone' */'@/views/project/siteregularCtms/p_project/milestonePlan')
    },
    {
      path: '/siteregularCtms/center/contacts',
      name: 'centercontacts',
      component: () => import(/* webpackChunkName: 'centercontacts' */'@/views/project/siteregularCtms/p_center/contacts')
    },
    {
      path: '/siteregularCtms/set',
      name: 'ctmsset',
      component: () => import(/* webpackChunkName: 'ctmsset' */'@/views/project/siteregularCtms/p_set/center')
    },
    {
      path: '/siteregularCtms/set/visit',
      name: 'visit',
      component: () => import(/* webpackChunkName: 'ctmsset' */'@/views/project/siteregularCtms/p_set/visit')
    },
    {
      path: '/siteregularCtms/set/member',
      name: 'ctmsMember',
      component: () => import('@/views/project/siteregularCtms/p_set/member')
    },
    {
      path: '/siteregularCtms/set/milestone',
      name: 'ctmsMilestone',
      component: () => import(/* webpackChunkName: 'ctmsMilestone' */'@/views/project/siteregularCtms/p_set/milestone')
    },
    {
      path: '/siteregularCtms/set/workflow',
      name: 'ctmsWorkflow',
      component: () => import(/* webpackChunkName: 'ctmsWorkflow' */'@/views/project/siteregularCtms/p_set/workflow')
    },
    {
      path: '/siteregularCtms/center/pd',
      name: 'centerpd',
      component: () => import(/* webpackChunkName: 'centerpd' */'@/views/project/siteregularCtms/p_center/pd')
    },
    {
      path: '/siteregularCtms/center/monitoringPlan',
      name: 'monitoringPlan',
      component: () => import(/* webpackChunkName: 'monitoringPlan' */'@/views/project/siteregularCtms/p_center/monitoringPlan')
    },
    {
      path: '/siteregularCtms/center/monitoring',
      name: 'monitoring',
      component: () => import(/* webpackChunkName: 'monitoring' */'@/views/project/siteregularCtms/p_center/monitoring')
    }
    ,
    {
      path: '/siteregularCtms/center/communicate',
      name: 'communicate',
      component: () => import(/* webpackChunkName: 'communicate' */'@/views/project/siteregularCtms/p_center/communicate')
    }
    ,

    {
      path: '/siteregularCtms/project/member',
      name: 'workHoursSet',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/member/index')
    },


    //研究中心
    {
      path: '/siteregularCtms/project/projectCenter',
      name: 'projectCenter',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/projectCenter/index')
    },


    //工时预算入组计划
    {
      path: '/siteregularCtms/project/enrollmentPlan',
      name: 'enrollmentPlan',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/enrollmentPlan/index')
    },
    //工时预算入组新增
    {
      path: '/siteregularCtms/project/enrollmentPlan/addWorkHours',
      name: 'enrollmentPlan',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/enrollmentPlan/components/addWorkPlan')
    },
    //工时预算计划新增
    {
      path: '/siteregularCtms/project/enrollmentPlan/addGroupPlan',
      name: 'enrollmentPlan',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/enrollmentPlan/components/addGroupPlan')
    },

    //中心里程碑
    {
      path: '/siteregularCtms/project/projectCenterMilestone',
      name: '/projectCenterMilestone',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/projectCenterMilestone/index')
    },

    //方案
    {
      path: '/siteregularCtms/project/plan',
      name: 'project/plan',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/plan/index')
    },
    // 访视
    {
      path: '/siteregularCtms/project/visitInfo/subjectInfo',
      name: 'subjectInfo',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/visitInfo/subjectInfo')
    },
    {
      path: '/siteregularCtms/project/visitInfo/visitInfo',
      name: 'visitInfo',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/visitInfo/visitInfo')
    },
    {
      path: '/siteregularCtms/project/visitInfo/add',
      name: 'visitInfo',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/visitInfo/components/add')
    },
    {
      path: '/siteregularCtms/project/document',
      name: 'visitInfo',
      component: () => import(/* webpackChunkName: 'phase' */'@/views/project/siteregularCtms/document/index')
    },

    //外包中心管理
    {
      path: '/siteregularCtms/outsourceCenter',
      name: 'outsourceCenter',
      component: () => import(/* webpackChunkName: 'outsourceCenter' */'@/views/project/siteregularCtms/outsourceCenter/index')
    },
    //供应商费用管理
    {
      path: '/siteregularCtms/vendorExpense',
      name: 'vendorExpense',
      component: () => import(/* webpackChunkName: 'vendorExpense' */'@/views/project/siteregularCtms/vendorExpense/index')
    },
    // 项目收款里程碑（PM）
    {
      path: '/siteregularCtms/project/paymentMilestone',
      name: 'paymentMilestone',
      component: () => import(/* webpackChunkName: 'paymentMilestone' */'@/views/project/siteregularCtms/p_project/paymentMilestone')
    },
    // 收款开票管理（商务）
    {
      path: '/siteregularCtms/project/paymentInvoice',
      name: 'paymentInvoice',
      component: () => import(/* webpackChunkName: 'paymentInvoice' */'@/views/project/siteregularCtms/p_project/paymentInvoice')
    },
  ]
}
